import merge from 'lodash/merge'
import React, { useContext as useContextCore } from 'react'
import { components as defaultComponents } from './components'
import { useAddOrder } from '../useAddOrder'
import { createDefault } from '@ztechapps/order.common'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = (props) => {
  const { children, afterSubmit } = props
  let { components } = props
  components = merge({}, defaultComponents, components)
  const orderDefault = createDefault()
  const initialValues = {
    ...orderDefault,
    code: '',
  }

  const validate = (values) => {
    const errors: any = {}
    if (!values.by?._id) {
      errors.by = 'Required'
    }

    return errors
  }

  const [onSubmit] = useAddOrder({ afterSubmit })

  return <CoreProvider value={{ ...props, validate, onSubmit, initialValues, components }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
//because we cannot do alias export, we do this
export const useAddOrderContext = useContext
